import React from 'react';

const FavouriteListHeadings = (props) => {
	return (
		<div className='col'>
			<h1>{props.heading}</h1>
		</div>
	);
};

export default FavouriteListHeadings;
